import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { appRoutes } from '../../config/docFile';
import PortalLayout from '../../master/portalLayout';
import NotFound from '../notFound';

const PortalLayoutWrapper = () => {
    
  const location = useLocation();
  useEffect(() => {
  console.log('App level pathname:', location.pathname);
}, [location]);

  return (
    <PortalLayout>
      <Routes>
        {appRoutes.map(({ path, useModule }) => (
          <Route key={path || 'index'} path={path} element={useModule} />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PortalLayout>
  );
};

export default PortalLayoutWrapper;
